// Intent-time preload seam for chat-side modules. Fire-and-forget; once per page load.
import { importConversationAssistantUI } from './import-conversation-assistant-ui';
import { importSmartCreationWrapper } from './ui/smart-creation-wrapper/import-smart-creation-wrapper';

let hasPreloadedChatOnIntent = false;

export function preloadChatOnIntent(): void {
	if (typeof window === 'undefined') {
		return;
	}

	if (hasPreloadedChatOnIntent) {
		return;
	}

	hasPreloadedChatOnIntent = true;

	void importSmartCreationWrapper().catch(() => {});
	// Warms the chunk behind ConversationAssistantConfigurerV2's lazy boundary so the first chat open
	// does not pay for the download. Harmless when V2 is off: the module is part of the eagerly loaded
	// graph in that case, so the import resolves from cache.
	void importConversationAssistantUI().catch(() => {});
}
